export const BaronSolid = (color) => {
  return `
        <svg xmlns="http://www.w3.org/2000/svg" width="400" height="181" viewBox="0 0 400 181" fill="none">
      <rect width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter0_ii_71_477)">
      <rect x="9.48315" y="9.09314" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter1_ii_71_477)">
      <rect x="140.666" y="9.09314" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter2_ii_71_477)">
      <rect x="271.058" y="9.09314" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="44.5512" x2="400" y2="44.5512" stroke="white" stroke-width="2"/>
      <rect width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter3_ii_71_477)">
      <rect x="9.48315" y="9.09314" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter4_ii_71_477)">
      <rect x="207.838" y="9.09314" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="44.5512" x2="400" y2="44.5512" stroke="#5D5D5D" stroke-opacity="0.66" stroke-width="2"/>
      <rect width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter5_ii_71_477)">
      <rect x="9.48315" y="9.09314" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter6_ii_71_477)">
      <rect x="140.666" y="9.09314" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter7_ii_71_477)">
      <rect x="271.058" y="9.09314" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="44.5512" x2="400" y2="44.5512" stroke="white" stroke-width="2"/>
      <rect width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter8_ii_71_477)">
      <rect x="9.48315" y="9.09314" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter9_ii_71_477)">
      <rect x="207.838" y="9.09314" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="45.0512" x2="400" y2="45.0512" stroke="#5D5D5D" stroke-opacity="0.66"/>
      <rect y="45" width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter10_ii_71_477)">
      <rect x="9.48315" y="54.0931" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter11_ii_71_477)">
      <rect x="140.666" y="54.0931" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter12_ii_71_477)">
      <rect x="271.058" y="54.0931" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="89.5512" x2="400" y2="89.5512" stroke="white" stroke-width="2"/>
      <rect y="45" width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter13_ii_71_477)">
      <rect x="9.48315" y="54.0931" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter14_ii_71_477)">
      <rect x="207.838" y="54.0931" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="90.0512" x2="400" y2="90.0512" stroke="#5D5D5D" stroke-opacity="0.66"/>
      <rect y="90" width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter15_ii_71_477)">
      <rect x="9.48315" y="99.0931" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter16_ii_71_477)">
      <rect x="140.666" y="99.0931" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter17_ii_71_477)">
      <rect x="271.058" y="99.0931" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="134.551" x2="400" y2="134.551" stroke="white" stroke-width="2"/>
      <rect y="90" width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter18_ii_71_477)">
      <rect x="9.48315" y="99.0931" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter19_ii_71_477)">
      <rect x="207.838" y="99.0931" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="135.051" x2="400" y2="135.051" stroke="#5D5D5D" stroke-opacity="0.66"/>
      <rect y="135" width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter20_ii_71_477)">
      <rect x="9.48315" y="144.093" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter21_ii_71_477)">
      <rect x="140.666" y="144.093" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter22_ii_71_477)">
      <rect x="271.058" y="144.093" width="118.539" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="179.551" x2="400" y2="179.551" stroke="white" stroke-width="2"/>
      <rect y="135" width="400" height="45.5512" fill="${color}"/>
      <g filter="url(#filter23_ii_71_477)">
      <rect x="9.48315" y="144.093" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <g filter="url(#filter24_ii_71_477)">
      <rect x="207.838" y="144.093" width="181.759" height="27.929" fill="#9B8E56"/>
      </g>
      <line y1="180.051" x2="400" y2="180.051" stroke="#5D5D5D" stroke-opacity="0.66"/>
      <defs>
      <filter id="filter0_ii_71_477" x="7.48315" y="7.09314" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter1_ii_71_477" x="138.666" y="7.09314" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter2_ii_71_477" x="269.058" y="7.09314" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter3_ii_71_477" x="7.48315" y="7.09314" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter4_ii_71_477" x="205.838" y="7.09314" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter5_ii_71_477" x="7.48315" y="7.09314" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter6_ii_71_477" x="138.666" y="7.09314" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter7_ii_71_477" x="269.058" y="7.09314" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter8_ii_71_477" x="7.48315" y="7.09314" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter9_ii_71_477" x="205.838" y="7.09314" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter10_ii_71_477" x="7.48315" y="52.0931" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter11_ii_71_477" x="138.666" y="52.0931" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter12_ii_71_477" x="269.058" y="52.0931" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter13_ii_71_477" x="7.48315" y="52.0931" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter14_ii_71_477" x="205.838" y="52.0931" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter15_ii_71_477" x="7.48315" y="97.0931" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter16_ii_71_477" x="138.666" y="97.0931" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter17_ii_71_477" x="269.058" y="97.0931" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter18_ii_71_477" x="7.48315" y="97.0931" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter19_ii_71_477" x="205.838" y="97.0931" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter20_ii_71_477" x="7.48315" y="142.093" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter21_ii_71_477" x="138.666" y="142.093" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter22_ii_71_477" x="269.058" y="142.093" width="122.539" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter23_ii_71_477" x="7.48315" y="142.093" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      <filter id="filter24_ii_71_477" x="205.838" y="142.093" width="185.759" height="31.929" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_477"/>
      <feOffset dx="-4" dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_477"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect2_innerShadow_71_477"/>
      <feOffset dx="4" dy="-4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="effect1_innerShadow_71_477" result="effect2_innerShadow_71_477"/>
      </filter>
      </defs>
      </svg>
        `;
};
